// Borradores locales de las indicaciones que se cargan dentro de una atención
// (evolución, prescripciones, órdenes, etc.). Se guardan en localStorage para
// no perder lo cargado si se corta internet, se cierra la pestaña o vence la
// sesión antes de finalizar. Como es información clínica, vencen solos y se
// borran al cerrar sesión.

const PREFIX = "indications-draft:";
export const DRAFT_TTL_MS = 24 * 60 * 60 * 1000;

const getKey = (userId, appointmentId) => `${PREFIX}${userId}:${appointmentId}`;

const isExpired = (draft) =>
  !draft?.savedAt || Date.now() - draft.savedAt > DRAFT_TTL_MS;

// localStorage puede no estar disponible (modo privado, cuota llena, sitio
// bloqueado); en ese caso el borrador simplemente no se guarda.
const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("No se pudo borrar el borrador de indicaciones:", error);
  }
};

const getDraftKeys = () => {
  try {
    return Object.keys(localStorage).filter((key) => key.startsWith(PREFIX));
  } catch (error) {
    return [];
  }
};

export function saveDraft(userId, appointmentId, content) {
  if (!userId || !appointmentId) return;
  try {
    localStorage.setItem(
      getKey(userId, appointmentId),
      JSON.stringify({ ...content, savedAt: Date.now() })
    );
  } catch (error) {
    console.error("No se pudo guardar el borrador de indicaciones:", error);
  }
}

export function getDraft(userId, appointmentId) {
  if (!userId || !appointmentId) return null;
  const key = getKey(userId, appointmentId);
  try {
    const draft = JSON.parse(localStorage.getItem(key));
    if (!draft) return null;
    if (isExpired(draft)) {
      safeRemove(key);
      return null;
    }
    return draft;
  } catch (error) {
    safeRemove(key);
    return null;
  }
}

export function removeDraft(userId, appointmentId) {
  if (!userId || !appointmentId) return;
  safeRemove(getKey(userId, appointmentId));
}

export function removeUserDrafts(userId) {
  if (!userId) return;
  getDraftKeys()
    .filter((key) => key.startsWith(`${PREFIX}${userId}:`))
    .forEach(safeRemove);
}

export function purgeExpiredDrafts() {
  getDraftKeys().forEach((key) => {
    try {
      if (isExpired(JSON.parse(localStorage.getItem(key)))) safeRemove(key);
    } catch (error) {
      safeRemove(key);
    }
  });
}

export default {
  saveDraft,
  getDraft,
  removeDraft,
  removeUserDrafts,
  purgeExpiredDrafts,
};
